uniform sampler2D uTexture;
uniform float uAlpha;
varying vec2 vUv;
varying vec4 vPosition;
uniform float uRadius;

vec3 srgbToLinear(vec3 c){
  return pow(c, vec3(2.2));
}


void main() {
  vec4 texColor = texture2D(uTexture, vUv);
  texColor.rgb = srgbToLinear(texColor.rgb);

  float normalizedY = (vPosition.y + uRadius) / (2.0 * uRadius);
  float transitionWidth = 0.1;
  float fadeMask = 1.0 - smoothstep(uAlpha - transitionWidth, uAlpha, normalizedY);
  
  gl_FragColor = vec4(texColor.rgb, texColor.a * fadeMask); 
  }